export enum LibraryTabs {
  TAGS,
}
